import { escapeRegExp, orderBy } from "lodash";
import { useMemo } from "react";
import { Campaign, CampaignSorting } from "./models";
import { SortOrderMap, SortValueGetterMap } from "./constant";
import { useQuery } from "react-query";

export function useCampaignsList(campaigns: Campaign[], sortCampaignsBy: CampaignSorting, searchValue: string) {
  const campaignList = useMemo(() => {
    if (!campaigns) return [];

    let filteredCampaigns = orderBy(
      [...campaigns],
      [SortValueGetterMap[sortCampaignsBy]],
      [SortOrderMap[sortCampaignsBy]]
    );
    if (searchValue) {
      const pattern = new RegExp(escapeRegExp(searchValue), "i");

      filteredCampaigns = campaigns.filter(campaign =>
        pattern.test(campaign.name as string)
      );
    }

    return filteredCampaigns;
  }, [sortCampaignsBy, searchValue, campaigns]);

  return campaignList;
}

export function useMessageTemplatesAPI() {
  return useQuery<Record<string, string>>({
    queryKey: ["messageTemplates"],
    queryFn: async () => {
      const response = await fetch("/api/my-fans/message-templates");
      if (!response.ok) {
        throw new Error("Failed to fetch message templates");
      }
      return response.json();
    }
  });
}
